import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

import PhotoPanel from './PhotoPanel';
import { BaseCard } from '../../../components/wizard';

class PhotoCard extends Component<any, any> {
  static propTypes: any;
  static defaultProps: any;

  render = () => {
    const { data = {}, extras, setItem, ...extraProps } = this.props;
    return (
      <Box>
        <BaseCard
          cardid={'PHOTO'}
          cardname={'Photo'}
          cardtitle={'Profile Photo'}
          instruction={'Upload a profile photo. This image will be uploaded to Cloudinary before submission.'}
          step={1}
          buttons={['START', 'CANCEL', 'PREV', 'NEXT', 'GUIDE']}
          {...extraProps}
        >
          <PhotoPanel
            data={data}
            extras={extras}
            setItem={setItem}
          />
        </BaseCard>
      </Box>
    );
  };
}

PhotoCard.propTypes = {
  classes: PropTypes.object,
};

export default PhotoCard;
